export class VerifyEmailConstants {
    public static USER_NAME = 'username';
    public static CODE = 'code';
}
